// Material Symbols icon names paired with each value proposition.
export const whyChooseUs = [
  {
    icon: "groups",
    title: "Professional & Dedicated Team",
    description:
      "A team of skilled professionals dedicated to delivering excellence in every aspect of our service.",
  },
  {
    icon: "lightbulb",
    title: "Unique Solutions",
    description:
      "We design customized, innovative logistics solutions tailored to meet your specific needs.",
  },
  {
    icon: "payments",
    title: "Affordable & Flexible",
    description:
      "Logistics solutions designed to fit a range of budget and time constraints, accessible to all.",
  },
  {
    icon: "support_agent",
    title: "24/7 Support",
    description:
      "Round-the-clock support to handle queries, address concerns, and keep you updated.",
  },
  {
    icon: "schedule",
    title: "Timely Delivery",
    description:
      "An efficient network and strategic partnerships ensure your shipments arrive on time, every time.",
  },
  {
    icon: "shield",
    title: "Quality & Safety",
    description:
      "Strict quality standards and robust security measures protect your cargo throughout its journey.",
  },
  {
    icon: "apps",
    title: "Wide Range of Services",
    description:
      "Storage, logistics management, cargo handling, trucking and more — all in one place.",
  },
  {
    icon: "eco",
    title: "Commitment to Sustainability",
    description:
      "We continuously work to minimise our environmental impact and contribute to a greener future.",
  },
];
